import React from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from '../../store/AuthContext';
import Location from "../../models/Location"
import PropsContainer from "../../components/props/PropsContainer"
import DimensionsService from "../../services/DimensionsService"
import NativeInterface from "../../services/NativeInterface"
import SettingsService from "../../services/SettingsService"
import { Accordion, Form, Button } from 'react-bootstrap';

import {PiArrowSquareOut} from 'react-icons/pi';

const EditLocationMain: React.FC<{data: Location, dimId: string}> = (props) => {
    const authCtx = React.useContext(AuthContext);
    const navigate = useNavigate();

    function updateLocation(params: any) {
        return DimensionsService.updateLocation('dev', props.dimId, props.data.id, params);
    }

    async function deleteHandler() {
        if (!window.confirm(`Do you want to delete location '${props.data.name}'?`)) {
            return;
        }
        console.log(`Deleting location: ${props.data.id}`);
        await DimensionsService.deleteLocation(props.dimId, props.data.id);
        navigate(`/edit-dimension?dim=${props.dimId}&tab=locations`);
    }

    function handleSceneEditor() {
        authCtx.setDimensionEnv(props.dimId!, 'dev');
        NativeInterface.launchNativeApp({dim: props.dimId, loc: props.data.id, edit: 1});
    }
    function handleCodeEditor() {
        if (authCtx.account.studio.canEditCode) {
            window.open(`${SettingsService.codeEditorHost()}/?dim=${props.dimId!}`, '_blank');
        } else {
            alert("Your account is not enabled for code editing");
        }
    }

    function handleLaunchEditor() {
        authCtx.setDimensionEnv(props.dimId, 'dev');
        NativeInterface.launchNativeApp({dim: props.dimId, loc: props.data.id, edit: 1});
    }

    function handleForceEnter() {
        NativeInterface.launchNativeApp({dim: props.dimId, loc: props.data.id, live: 1, force: 1});
    }

    function handleForcePlacement() {
        NativeInterface.launchNativeApp({dim: props.dimId, loc: props.data.id, live: 1, place: 1});
    }

    return (
        <>
            <div className="d-flex align-items-center" style={{marginBottom: "var(--margin-half)"}}>
                <h3>{props.data.name}</h3>
                <div className="d-flex flex-fill justify-content-end">
                    {!NativeInterface.isPWA() && (
                        <>
                            <Button className="me-3" variant="primary" onClick={handleSceneEditor}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    Scene Editor
                                    <PiArrowSquareOut size={24} style={{ marginLeft: '8px' }} />
                                </span>
                            </Button>
                            <Button className="me-3" variant="primary" onClick={handleCodeEditor}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    Code Editor
                                    <PiArrowSquareOut size={24} style={{ marginLeft: '8px' }} />
                                </span>
                            </Button>
                        </>
                    )}
                    {NativeInterface.isPWA() && (
                        <Button className="me-3" style={{width: "200px"}} variant="primary" onClick={handleLaunchEditor}>Live Editor</Button>
                    )}
                </div>
            </div>
            <PropsContainer properties={props.data.properties} doSave={updateLocation}/>
            
            <Accordion>

                {NativeInterface.isPWA() && (
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Force View</Accordion.Header>
                        <Accordion.Body>
                            <Button className="m-1" style={{width: "150px"}} variant="primary" onClick={handleForceEnter}>Force Enter</Button>
                            <Button className="m-1" style={{width: "150px"}} variant="primary" onClick={handleForcePlacement}>Force Placement</Button>
                        </Accordion.Body>
                    </Accordion.Item>
                )}

                <Accordion.Item eventKey="1">
                    <Accordion.Header>Advanced</Accordion.Header>
                    <Accordion.Body>
                        <Button variant="danger" onClick={deleteHandler}>Delete Location</Button>
                    </Accordion.Body>
                </Accordion.Item>

            </Accordion>
        </>
    );
};

export default EditLocationMain;
